import { useEffect, useState } from 'react';
import axios from 'axios';
import { HTTP } from '../lib/httpStatus';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/** Fetch a single published blog post by slug. */
export const useBlogPost = (slug) => {
  const [post, setPost] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    let active = true;
    setIsLoading(true);
    setNotFound(false);

    axios
      .get(`${BACKEND_URL}/api/blog/posts/${slug}`)
      .then(({ data }) => {
        if (active) setPost(data);
      })
      .catch((err) => {
        if (!active) return;
        if (err.response?.status === HTTP.NOT_FOUND) setNotFound(true);
        setPost(null);
      })
      .finally(() => {
        if (active) setIsLoading(false);
      });

    return () => {
      active = false;
    };
  }, [slug]);

  return { post, isLoading, notFound };
};

/** Fetch all published blog posts (for the index page). */
export const useBlogList = () => {
  const [posts, setPosts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let active = true;
    axios
      .get(`${BACKEND_URL}/api/blog/posts`)
      .then(({ data }) => {
        if (active) setPosts(data.posts || []);
      })
      .catch(() => {
        if (active) setPosts([]);
      })
      .finally(() => {
        if (active) setIsLoading(false);
      });
    return () => {
      active = false;
    };
  }, []);

  return { posts, isLoading };
};
